<template>
  <div class="v-row">
    <span class="displaySpan">
      {{ display }}
    </span>
    <span class="openButtonHolder">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <span class="openButton" v-on="on">☰</span>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in options"
            :key="index"
            @click="selectionMade(item)"
          >
            <v-list-item-title>{{ formatSpan(item, true) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </span>
  </div>
</template>

<script>
const options = [1, 7, 30, 60];

export default {
  name: "ClusterTimeRangePicker",
  data: function () {
    return {
      selected: 7,
      options: options,
    };
  },
  computed: {
    display() {
      return this.formatSpan(this.selected, true);
    },
  },
  methods: {
    formatSpan(num, caps) {
      if (num === 1 && caps) {
        return "Last 24 Hours";
      } else if (num === 1) {
        return "last 24 hours";
      } else if (caps) {
        return "Last " + num + " Days";
      }
      return "Last " + num + " days";
    },
    selectionMade(selected) {
      this.selected = selected;
      this.$emit("selectionChanged", {
        val: this.selected,
        display: this.formatSpan(this.selected, false),
        displayCaps: this.formatSpan(this.selected, true),
      });
    },
  },
};
</script>

<style scoped>
.openButton {
  cursor: pointer;
}

.openButtonHolder {
  float: right;
}

.displaySpan {
  padding-left: 7px;
}
</style>
